import { inject, provide } from 'vue';

import type { IGroupItemProvide } from '@components/composable';
import type { ComputedRef, InjectionKey, Ref } from 'vue';

export interface ICdsContainerProvide {
  rootRef: Ref<HTMLElement | undefined>;
  transition: ComputedRef<undefined | string>;
  transitionCount: Ref<number>;
  transitionHeight: Ref<undefined | string>;
  isReversed: Ref<boolean>;
  onlySingle: Ref<boolean>;
  multiple: Ref<boolean>;
}

export const CdsContainerSymbol: InjectionKey<ICdsContainerProvide> = Symbol.for('cds:container');
export const CdsContainerGroupSymbol: InjectionKey<IGroupItemProvide> = Symbol.for('cds:container-group');

export const useProvideContainer = (data: ICdsContainerProvide) => {
  provide(CdsContainerSymbol, data);
};

export const useInjectContainer = () => {
  return inject(CdsContainerSymbol, {} as ICdsContainerProvide);
};
